import { render, staticRenderFns } from "./TalkBtn.vue?vue&type=template&id=65451037&scoped=true&"
import script from "./TalkBtn.vue?vue&type=script&lang=js&"
export * from "./TalkBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65451037",
  null
  
)

export default component.exports